import React, { useState } from "react";
import {FormControl, FormControlLabel, Radio, RadioGroup, Switch} from "@mui/material";

export function CxRadioSelection({name, initialValue, onChange, radioItems}) {

    const [selectedValue, setSelectedValue] = useState(initialValue);

    const handleChange = (event) => {
        const value = event.target.value;   // get new selection
        setSelectedValue(value);            // set current selection to new value
        if (onChange) onChange(value);      // call the parent's handler if available
    };

    return (
        <FormControl>
            <RadioGroup
                row
                name={name}
                value={selectedValue}
                onChange={handleChange}
            >

                {radioItems.map((item) => (
                    <FormControlLabel key={item.value} control={<Radio />} value={item.value} label={item.label} />
                ))}

            </RadioGroup>
        </FormControl>
    );
}


export function CxSwitch({name, label, checked, onChange, disabled=false}) {

    const handleChange = (event) => {
        if (onChange) onChange(event.target.checked);
    };

    return (
        <FormControlLabel
            control={
                <Switch  name={name} checked={checked} disabled={disabled}
                         onChange={handleChange} inputProps={{ 'aria-label': 'controlled' }} />
            }
            label={label}
        />
    );
}

